"use strict";

var React = require("react");

var SvgIconEditV1 = function SvgIconEditV1() {
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: "1em",
      height: "1em",
      viewBox: "0 0 13 13",
    },
    /*#__PURE__*/ React.createElement(
      "g",
      {
        fill: "currentColor",
        fillRule: "evenodd",
      },
      /*#__PURE__*/ React.createElement("path", {
        d:
          "M7.572 1.133l-1.6 1.6H2.733a1 1 0 00-1 1v6.534a1 1 0 001 1h6.534a1 1 0 001-1v-3.24l1.6-1.6v5.44a2 2 0 01-2 2H2.133a2 2 0 01-2-2V3.133a2 2 0 012-2h5.44z",
        fillRule: "nonzero",
      }),
      /*#__PURE__*/ React.createElement("path", {
        d:
          "M3.867 7.243v1.89h1.89l5.576-5.576-1.89-1.89-5.576 5.576zm8.934-5.34a.452.452 0 000-.64L11.738.198a.452.452 0 00-.64 0l-.831.831 1.703 1.703.83-.83z",
      })
    )
  );
};

exports["foreignIcon"] = SvgIconEditV1;
